import { Col, Form, Input, Row, Select } from "antd";
import { Button as BootstrapButton } from "react-bootstrap";
import { CustomDropdownSelect } from "../../../../components";
import { eSystemType } from "../../../../models/ISoftware";
import { RegExp } from "../../../../constants";

interface InsertSoftwareFormProps {
  onSubmit: (values: any) => void;
  software: any;
  teamOptions: any[];
}

export const InsertSoftwareForm = (props: Partial<InsertSoftwareFormProps>) => {
  const { onSubmit = () => {}, software, teamOptions } = props;
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    onSubmit({ ...(software ?? {}), ...values });
  };

  return (
    <Form
      name="dynamic_form_nest_item"
      autoComplete="off"
      form={form}
      size="large"
      layout="vertical"
      onFinish={onFinish}
      initialValues={software}
    >
      <Row gutter={[32, 0]}>
        <Col span={12}>
          <Form.Item
            required
            label="Mã quy trình"
            name="eSystemCode"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập mã quy trình!",
              },
            ]}
          >
            <Input disabled={!!software}/>
          </Form.Item>
          <Form.Item
            required
            label="Tên quy trình"
            name="Title"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập tên quy trình!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Mô tả" name="eDescription" rules={[]}>
            <Input />
          </Form.Item>
          <Form.Item
            required
            label="Nhóm phát triển"
            name="eTeam"
            rules={[
              {
                required: true,
                message: "Vui lòng chọn trường này!",
              },
            ]}
          >
            <CustomDropdownSelect
              options={teamOptions}
              className="min-w-full"
              addInputPlaceholder="Nhập nhóm phát triển"
              addButtonText="+ Thêm nhóm phát triển"
              key="key"
              placeholder="Vui lòng chọn nhóm phát triển"
            />
          </Form.Item>
          <Form.Item
            required
            label="Loại quy trình"
            name="eSystemType"
            // rules={[
            //   {
            //     required: true,
            //     message: "Vui lòng chọn trường này!",
            //   },
            // ]}
          >
            <Select options={eSystemType} className="min-w-full" key="key" placeholder="Vui lòng chọn loại quy trình" />
          </Form.Item>
          {/* <Form.Item
            required
            label="Chức vụ"
            name="eBizTitleCode"
            rules={[
              {
                required: true,
                message: "Vui lòng chọn trường này!",
              },
            ]}
          >
            <CustomDropdownSelect
              options={eBizTitleOptions}
              className="min-w-full"
              addInputPlaceholder="Nhập chức vụ"
              addButtonText="+ Thêm chức vụ"
              key="key"
              placeholder="Vui lòng chọn chức vụ"
            />
          </Form.Item> */}
        </Col>
        <Col span={12}>
          <Form.Item
            required
            label="Email bước 2"
            name="eITTeamLead"
            rules={[
              {
                type: "email",
                message: "E-mail không hợp lệ!",
              },
              {
                message: "E-mail phải kết thúc bằng @viags.vn!",
                pattern: RegExp.viagsEmail,
              },
              {
                required: true,
                message: "Vui lòng nhập E-mail!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            required
            label="Họ tên bước 2"
            name="eTeamLeadName"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập họ tên!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            required
            label="Email bước 3"
            name="eITHead"
            rules={[
              {
                type: "email",
                message: "E-mail không hợp lệ!",
              },
              {
                message: "E-mail phải kết thúc bằng @viags.vn!",
                pattern: RegExp.viagsEmail,
              },
              {
                required: true,
                message: "Vui lòng nhập E-mail!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            required
            label="Họ tên bước 3"
            name="eITHeadName"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập họ tên!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            required
            label="Email người duyệt bước 4"
            name="eITStaffMail"
            rules={[
              {
                type: "email",
                message: "E-mail không hợp lệ!",
              },
              {
                message: "E-mail phải kết thúc bằng @viags.vn!",
                pattern: RegExp.viagsEmail,
              },
              {
                required: true,
                message: "Vui lòng nhập E-mail!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            required
            label="Họ tên người duyệt bước 4"
            name="eITStaffName"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập họ tên người duyệt bước 4!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <div className="flex-end">
        <BootstrapButton variant="success" type="submit">
          Xác nhận
        </BootstrapButton>
      </div>
    </Form>
  );
};
